export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10833.c89a8bf4.jpg";